import moment from 'moment';

export function setImagevariant(url, width) {
  return url ? url.replace('${width}', width) : '';
}

export function readableTime(t, what) {
    const tempTime = moment.duration(t, what);
    const hours = tempTime.hours();
    const days = tempTime.days();
    if(hours) {
      return (days * 24) + hours + 'h ' + tempTime.minutes().toString().padStart(2, '0') + 'm';
    }
    return tempTime.minutes().toString().padStart(2, '0') + ' min';
}

export function makeID(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}